import { render, staticRenderFns } from "./loginChangeTrainsUser.vue?vue&type=template&id=3bc35eda&"
import script from "./loginChangeTrainsUser.vue?vue&type=script&lang=ts&"
export * from "./loginChangeTrainsUser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports